/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ideal_Grassy_Puffin_RiseInputs */

const fr_ideal_grassy_puffin_rise = /** @type {(inputs: Ideal_Grassy_Puffin_RiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semaine suivante`)
};

/**

* @param {Ideal_Grassy_Puffin_RiseInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const ideal_grassy_puffin_rise = /** @type {((inputs?: Ideal_Grassy_Puffin_RiseInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ideal_Grassy_Puffin_RiseInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_ideal_grassy_puffin_rise(inputs)
});